// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import classNames from 'classnames'
import { Row, Col } from '../../../../components/Elemental'
import { Calendar } from 'react-feather'

// CSS
import './styles.scss'

// Components
import ProfileIcon from '../../../../components/ProfileIcon'

// Constants
import { getStatusName, formatDate } from '../../../../constants/others'

const MyCasesPageCard = ({
  id,
  to,
  role,
  status,
  origin,
  timeLeft,
  lawsuitNumber,
  turn,
  client,
  lawyer,
  company,
  lawFirm,
  guaranteed,
  lastMessage,
  notifications,
  remainingTime,
  admin
}) => {
  let notificationReturn = ''

  notifications.map(notification => {
    if (notification.proposta_id === id) {
      switch (notification.status) {
        case 1:
          notificationReturn = 'Clique aqui e inicie a negociação'
          break;
        case 2:
          switch (notification.sub_status) {
            case 1:
              notificationReturn = 'O caso está aguardando proposta'
              break;
            case 2:
              notificationReturn = 'O caso recebeu uma nova mensagem'
              break;
            default:
          }
          break;
        case 3:
          switch (notification.sub_status) {
            case 1:
              notificationReturn = 'O caso está aguardando minuta'
              break;
            case 2:
              notificationReturn = 'O caso recebeu uma nova mensagem'
              break;
            case 3:
              notificationReturn = 'O caso recebeu uma minuta'
              break;
            case 4:
              notificationReturn = 'O caso está aguardando protocolo'
              break;
            default:
          }
          break;
        default:
          notificationReturn = 'Ocorreu alteração no seu caso'
      }
    }
  })

  const myCasesPageCardStatus = `my-cases-page-card--status-${status}`
  const MyCasesClassName = classNames(
    'my-cases-page-card',
    { [myCasesPageCardStatus]: status },
    { 'my-cases-page-card--pending': notificationReturn }
  )

  const clockColor = (remainingTime) => {
    if (remainingTime <= 10) {
      return 'red'
    }
    else if (remainingTime <= 25) {
      return 'yellow'
    }
    else {
      return 'black'
    }
  }


  return (
    <NavLink
      to={to}
      className={MyCasesClassName}>
      <div className={`my-cases-page-card__header`}>
        <div>{id}</div>
        <div>
          {(turn === 1 && admin) && <div className={`my-cases-page-card__header__clock my-cases-page-card__header__clock--${clockColor(remainingTime)}`}>
            <Calendar size={14} />
            <div>{remainingTime}</div>
          </div>}
          {`${getStatusName(status)}`}</div>
      </div>
      <div className="my-cases-page-card__content">
        <ul>
          {origin === 1 && <h6>CPF Cliente</h6>}
          {origin === 2 && <h6>Processo</h6>}
          <h6>Parte</h6>
          <h6>Advogado</h6>
          <h6>Empresa</h6>
        </ul>
        <ul>
          {origin === 1 && <h6>{client.cpf}</h6>}
          {origin === 2 && <h6>{lawsuitNumber}</h6>}
          <h6>{client.fullName.toLowerCase()}</h6>
          <h6>{lawyer.fullName.toLowerCase()}</h6>
          <h6>{(company.fantasyName ? company.fantasyName : company.name).toLowerCase()}</h6>
        </ul>
      </div>
      <div className="my-cases-page-card__updates">
        <h6>
          {notificationReturn ? notificationReturn : `Última alteração em ${lastMessage.date && formatDate(lastMessage.date)}`}
        </h6>
        {!Boolean(guaranteed) && notificationReturn && <span />}
        {Boolean(guaranteed) && <div className="my-cases-page-card__tag">Garantido</div>}
      </div>
    </NavLink>
  )
}

export default MyCasesPageCard
